"use client"

import { somethingWrong } from '@/assets/imgs'
import { useTranslations } from 'next-intl'
import Image from 'next/image'

const Error505 = () => {
  const  t  = useTranslations('errors')
  return (
    <div className='flex h-screen min-h-screen items-center justify-center'>
      <div className='flex h-full w-full flex-col items-center justify-center gap-8 pb-10 lg:gap-0'>
        <div className='flex-1'>
          <Image alt='something went wrong' src={somethingWrong} className='h-full' />
        </div>
        <div>
          <button
            onClick={() => location.reload()}
            className='w-fit rounded-full border border-primary bg-white px-10 py-4 text-sm font-semibold text-secondary transition-all duration-200 hover:border-transparent hover:bg-linear-to-r hover:from-primary hover:from-10% hover:to-secondary hover:text-white sm:text-lg lg:mt-0'
          >
            {t('errors.reload')}
          </button>
        </div>
      </div>
    </div>
  )
}

export default Error505
